<template>
  <div>
    <!--<div class="module-menu">TODO</div>-->
    <router-view class="module-container"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'modules'
  }
</script>

<style scoped>

</style>